<script>
import Api from '@/components/Api/Api'
import axios from 'axios'
import Producto from '@/models/Producto'
import Cliente from '@/models/Cliente'
//import Xml from '@/models/Xml'
import Estado from '@/models/Estado'
import Vue from 'vue'
var PizZip = require('pizzip')
var Docxtemplater = require('docxtemplater')
import NumeroALetras from '../assets/numletras.js'

let Docxgen = new Vue({
  name: 'Docxgen',
  data: {
    yo: Api.fetchLocal('hb3.yo') || {},
    empresa: Api.fetchLocal('hb3.empresadb') || {},
    usarFechaFacturaEnLugarDeFechaTimbrado: true
  },
  methods: {
    async docxSimple(datos, plantillaEnDom, devolver) {
      console.log("docxSimple", {
        datos,
        plantillaEnDom,
        devolver
      })
      let vm = this
      return new Promise(async (resolve, reject) => {
        try {
          let doc = new Docxtemplater()
          let plantilla
          if (plantillaEnDom.startsWith('#'))
            plantilla = await Api.upload(plantillaEnDom, 'binario')
          else
            plantilla = plantillaEnDom
          let zip = new PizZip(plantilla)
          doc.loadZip(zip)
          doc.setData(datos)
          doc.render()
          let buffer = doc.getZip().generate({
            type: 'nodebuffer'
          })
          console.log("Buffer", buffer.length)
          if (!devolver)
            vm.downloadFile(buffer, datos._id + '.docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')
          else
            resolve(buffer)
        } catch (e) {
          reject(e)
        }
      })
    },
    async instalarPlantilla(plantilla) {
      let ruta = window.location.origin + '/static/' + plantilla.archivo
      console.log("instalarPlantilla?", ruta)
      try {
        let archivo = await axios.get(ruta, {
          responseType: 'blob'
        })
        archivo = await new Promise((resolve, reject) => {
          var reader = new FileReader();
          reader.onload = function() {
            var b64 = reader.result.replace(/^data:.+;base64,/, '');
            console.log('b64?', b64.length)
            resolve(b64)
          }
          reader.readAsDataURL(archivo.data)
        })
        //
        console.log("Archivo raw?", archivo)
        console.log("instalarPlantilla archivo", archivo.length, typeof archivo, archivo.toString().substring(0, 30))
        this.subirPlantillaDOCX((archivo), plantilla.nombre, true)
      } catch (e) {
        toast("No se pudo instalar la plantilla")
        console.error("EINSTALARPLANTILLA", e)
      }
      return Promise.resolve(true)
    },
    async subirPlantillaDOCX(file, descr, entradaYaEsBase64) {
      file = file || ''
      descr = descr || 'Default'
      entradaYaEsBase64 = entradaYaEsBase64 && true
      if (file == '')
        file = await Api.upload('#docx', 'binario')
      console.log("Subiendo plantilla?", file.length)
      this.docx = file
      let plantilla = {
        fecha: new Date().getTime(),
        data: entradaYaEsBase64 ? file : btoa(file),
        idAutor: this.yo._id,
        nombre: descr
      }
      if (plantilla.nombre == 'Default')
        plantilla.nombre = prompt('Introduzca un nombre para la plantilla', 'Default')
      // Borrar las plantillas que ya se llamen así
      let existentes = await Api.find('plantilladocx', ['nombre,eq,' + plantilla.nombre])
      if (existentes.length > 0) {
        toast("Eliminando duplicados")
        for (let e of existentes) {
          console.log("Encontrado duplicado?", e.data.replace(plantilla.data, ''), e.data.length, plantilla.data.length)
          await Api.delete('plantilladocx', e._id)
        }
      }
      //
      await Api.save('plantilladocx', plantilla)
      toast("Plantilla " + plantilla.nombre + " subida")
      // Procesar
      if (false && !Api.modoProduccion)
        try {
          var doc = new Docxtemplater()
          var zip = new PizZip(this.docx)
          console.log("zip?", zip)
          doc.loadZip(zip);
          doc.setData({
            'INVOICE_HOUR': 'Hola mundo perros',
            first_name: 'John',
            last_name: 'Doe',
            phone: '0652455478',
            description: 'New Website'
          })
          doc.render()
          console.log("Generado?", doc)
          let buffer = doc.getZip().generate({
            type: 'nodebuffer'
          })
          console.log("Buffer", buffer)
          this.downloadFile(buffer, 'plantillaNueva.docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')
        } catch (error) {
          console.error(error)
          toast("No se pudo procesar el documento")
        }
      return Promise.resolve(true)
    }
  },
  created() {
    console.log("Docxgen created")
  }
})
export default Docxgen
</script>
